import React, { useCallback, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';

import Header from '../../../components/header/Header';
import useR05Api from '../../../api/useR05Api';
import CenterLoading from '../../../components/CenterLoading/CenterLoading';
import TextCopy from '../../../components/TextCopy';
import IcNext from '../../../assets/imgs/ic_top.svg?react';
import { DISTRIBUTION_STATUS } from '../../../utils/Constants';

import styles from './styles.module.css';
import { Distributions } from 'types/distributions';

const BoughtDistributionsInfoScreen = () => {
    const [isLoading, setIsLoading] = useState(false);
    const [distributionsInfoList, setDistributionsInfoList] = useState<Distributions[]>([]);
    const { t } = useTranslation();
    const location = useLocation();
    const { orderTicketId } = location.state ?? {};
    const { fetchDistributionsInfo } = useR05Api();

    const fetchDistributionsData = useCallback(async () => {
        try {
            setIsLoading(true);
            const response = await fetchDistributionsInfo({ orderTicketId: orderTicketId });
            setDistributionsInfoList(response);
            setIsLoading(false);
        } catch {
            setIsLoading(false);
        }
    }, [fetchDistributionsInfo, orderTicketId]);

    useEffect(() => {
        void fetchDistributionsData();
    }, [fetchDistributionsInfo, orderTicketId]);

    const getDistributionStatus = (distributionsInfo: Distributions) => {
        switch (distributionsInfo.status) {
            case DISTRIBUTION_STATUS.RECEIVED:
                return t('distributions.received');
            case DISTRIBUTION_STATUS.USED:
                return t('distributions.used');
            case DISTRIBUTION_STATUS.SEPARATED:
                return t('distributions.separated');

            default:
                return '';
        }
    };

    return (
        <>
            <Header title={t('header.distributions-info')} refetch={() => void fetchDistributionsData()} />
            {isLoading && <CenterLoading />}
            <div className={`content-container scrollable ${styles.container}`}>
                {distributionsInfoList.length > 0 ? (
                    <>
                        <div className={styles.title}>{t('distributions.info-title')}</div>
                        {distributionsInfoList.map((distributionsInfo, index) => {
                            return (
                                <div
                                    key={index}
                                    className={`${styles.wrapper} ${
                                        distributionsInfo?.status === DISTRIBUTION_STATUS.USED ? styles.disabled : ''
                                    }`}
                                >
                                    <div className={styles.content}>
                                        <div className={styles.flexRows}>
                                            <p className={styles.no}>
                                                {t('ticket-detail.coupon-ordinal', { number: index + 1 })}
                                            </p>
                                            <p
                                                className={styles.status}
                                                style={
                                                    distributionsInfo?.status === DISTRIBUTION_STATUS.SEPARATED
                                                        ? { color: 'red' }
                                                        : {}
                                                }
                                            >
                                                {getDistributionStatus(distributionsInfo)}
                                            </p>
                                        </div>

                                        {/* <div className={styles.item}>
                                            <span>{t('distributions.link')}:</span>
                                            {distributionsInfo.distributionAppBaseUrl}
                                        </div> */}
                                        {/* <div className={styles.item}>
                                            <span>{t('distributions.code')}:</span>
                                            {distributionsInfo.distributionCode}
                                        </div> */}
                                    </div>
                                    <div className={styles.actions}>
                                        <div
                                            className={styles.action}
                                            style={{
                                                padding: 0,
                                            }}
                                        >
                                            <TextCopy
                                                disabled={distributionsInfo?.status === DISTRIBUTION_STATUS.USED}
                                                label={t('distributions.link-copy') ?? ''}
                                                isPrimaryColor
                                                canWrapperClick
                                                wrapperStyle={{
                                                    width: '100%',
                                                    height: '100%',
                                                    display: 'flex',
                                                    justifyContent: 'center',
                                                }}
                                                style={{ textAlign: 'center' }}
                                            >
                                                {`${distributionsInfo.url}?receiveId=${distributionsInfo.distributionCode}`}
                                            </TextCopy>
                                        </div>
                                        <div
                                            className={`${styles.action} ${
                                                distributionsInfo?.status === DISTRIBUTION_STATUS.USED
                                                    ? styles.disabled
                                                    : ''
                                            }`}
                                            onClick={() => {
                                                if (distributionsInfo?.status === DISTRIBUTION_STATUS.USED) {
                                                    return;
                                                }
                                                window.open(
                                                    `${distributionsInfo.url}?receiveId=${distributionsInfo.distributionCode}`,
                                                    '_blank',
                                                );
                                            }}
                                        >
                                            <p
                                                className={`${
                                                    distributionsInfo?.status === DISTRIBUTION_STATUS.USED
                                                        ? styles.disabled
                                                        : ''
                                                }`}
                                            >
                                                {t('distributions.link-open')}
                                            </p>
                                            <IcNext
                                                className={`${styles.icNext} ${
                                                    distributionsInfo?.status === DISTRIBUTION_STATUS.USED
                                                        ? styles.disabled
                                                        : ''
                                                }`}
                                            />
                                        </div>
                                    </div>
                                </div>
                            );
                        })}
                    </>
                ) : (
                    <div className={styles.noData}>{t('loading.small-bought-ticket-list')}</div>
                )}
            </div>
        </>
    );
};

export default BoughtDistributionsInfoScreen;
